module.exports = __webpack_public_path__ + "HT.png?ad8e6fd6edaf1b812000efc07f3f3f2c";